import { WEB_VIEW_MODE_SUB_URL } from "../constants";

export const isWebView = () =>
  window.location.pathname.includes(WEB_VIEW_MODE_SUB_URL);
